import React, { useState, useContext, useCallback } from 'react';
import * as Sentry from '@sentry/browser';
import { APIContext } from '@monash/portal-frontend-common';
import { RouterState } from '@monash/portal-react';

export const SearchContextHoneycomb = React.createContext();

const SearchProviderHoneycomb = ({ children }) => {
  const [searchError, setSearchError] = useState(false);

  const { search, searchSuggestions } = useContext(APIContext);

  const { route, redirect } = useContext(RouterState);

  const loadSearchString = () => {
    if (route.data) return route.data;
    const search = new URLSearchParams(window.location.search);
    return search.get('query') || '';
  };

  const [searchTarget, setSearchTarget] = useState(loadSearchString || '');
  const [loadingLinks, setLoadingLinks] = useState(true);
  const [runSearchCallCount, setRunSearchCallCount] = useState(0);
  const [searchResult, setSearchResult] = useState();
  const [searchSuggestionsResult, setSearchSuggestionsResult] = useState();
  const [categories, setCategories] = useState();

  const runSearch = async (target = searchTarget, goToSearch = true) => {
    target && setSearchTarget(target);
    setLoadingLinks(true);
    try {
      const commonSearch = await search(target, [], [], 'link', {
        includePersonalisationRelevance: true,
      });

      setSearchResult(commonSearch.results);
      setSearchError(false);
    } catch (error) {
      setSearchError(error);
    } finally {
      setLoadingLinks(false);
      setRunSearchCallCount((prev) => prev + 1);
    }

    goToSearch && redirect(`/search?query=${target}`, searchTarget);
  };

  const runSearchSuggestions = useCallback((target) => {
    searchSuggestions(target)
      .then((commonSearch) => {
        setSearchSuggestionsResult(commonSearch);
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  }, []);

  return (
    <SearchContextHoneycomb.Provider
      value={{
        searchTarget,
        setSearchTarget,
        loadingLinks,
        searchResult,
        runSearch,
        runSearchCallCount,
        runSearchSuggestions,
        searchSuggestionsResult,
        searchError,
        categories,
        setCategories,
      }}
    >
      {children}
    </SearchContextHoneycomb.Provider>
  );
};

export default SearchProviderHoneycomb;
